import { useState } from 'react';

// The signed-in person's picture wherever the merchant shell shows it (top-bar menu,
// its header, the Account band): the uploaded photo (`avatar_url`), or the name's
// initial when there is none — and also when the photo fails to load, so a bad URL
// never leaves a broken-image icon. A failed URL is remembered until it changes (a new
// upload carries a new `?v=`). Styling stays with the caller's own design class.
export function UserAvatar({
  src,
  name,
  className,
  imgClassName,
}: {
  src: string | null | undefined;
  name: string | undefined;
  className: string;
  imgClassName?: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  if (src && failed !== src) {
    return <img className={imgClassName ?? className} src={src} alt="" decoding="async" onError={() => setFailed(src)} />;
  }
  return (
    <span className={className} aria-hidden="true">
      {(name ?? '').trim().charAt(0).toUpperCase()}
    </span>
  );
}
